<div class="version-updated toast info" *ngIf="hasUpdates && !closed">
  Доступна новая версия, обновите страницу. <a href="javascript:;" (click)="reload()" class="refresh-link">обновить</a>

  <a href="javascript:;" class="close" (click)="close()"><mtg-svg-icon icon="icons-close"></mtg-svg-icon></a>
</div>
